import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-372a2f3c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top_title"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0
};
export default /*#__PURE__*/_defineComponent({
  __name: 'TopTitle',
  props: {
    title: {
      type: String
    },
    btnName: {
      type: String
    },
    showRightBtn: {
      type: Boolean,
      default: true
    }
  },
  emits: ['add'],
  setup(__props, {
    emit
  }) {
    const operateFun = () => {
      emit('add');
    };
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1), __props.showRightBtn ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("a", {
        onClick: operateFun,
        class: "operate_btn"
      }, [_createVNode(_component_svg_icon, {
        "icon-class": "add_no_color",
        "class-name": "add-icon"
      }), _createTextVNode(" " + _toDisplayString(__props.btnName), 1)])])) : _createCommentVNode("", true)]);
    };
  }
});